/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { knowledgeHubArticleEmbedEditorRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/knowledgeHubArticleEmbedEditorRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeArticleEmbedEditor, {
	LazyServiceDeskKnowledgeArticleEmbedEditor,
} from './ui/kb-article-embed-editor/index.tsx';

export const knowledgeHubArticleEmbedEditorRouteEntry: Route = createEntry(
	knowledgeHubArticleEmbedEditorRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskKnowledgeArticleEmbedEditor,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getKnowledgeHubResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceDeskKnowledgeArticleEmbedEditor],
		perfMetricKey: 'service-management.knowledge.ep-editor',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
